import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import TipCard from "@/components/feature/TipCard";
import type { Tip } from "@/types/content";

export default function FeedSection({ list }: { list: Tip[] }) {
  return (
    <section id="latest" className="bg-background-50 py-14 md:py-20" aria-label="最新爆料">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            kicker="刚刚发生"
            title="最新爆料"
            desc="按发布时间排列的最新投稿，很多内容发布不到一天就已经有了几条认真讨论。"
          />
          <Link
            to="/feed"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            进入爆料广场
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((tip) => (
            <TipCard key={tip.id} tip={tip} />
          ))}
        </div>
      </div>
    </section>
  );
}